import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms'

import { minLengthFn } from './validator'

const MIN_LENGTH_VALIDATOR: any = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => MinLengthValidator),
    multi: true
}

@Directive({
    selector: '[minLength][formControlName],[minLength][formControl],[minLength][ngModel]',
    providers: [MIN_LENGTH_VALIDATOR]
})
export class MinLengthValidator implements Validator, OnInit, OnChanges {
    @Input() minLength: number

    private validator: ValidatorFn
    private onChange: () => void

    ngOnInit() {
        this.validator = minLengthFn(this.minLength)
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const key in changes) {
            if (key === 'minLength') {
                this.validator = minLengthFn(changes[key].currentValue)
                if (this.onChange) { this.onChange() }
            }
        }
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c)
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onChange = fn
    }
}
